import { type Layout, sections, singleRow } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { getStringRibbonId } from 'owa-ribbon-ids';
import { type MailRibbonControlId, type MailRibbonGroupId } from 'owa-ribbon-ids/lib/mailRibbonId';

export const getMLRSendReceiveTabGroupLayouts: (
    group: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps
) => Layout[] | undefined = owaComputedFn(function getMLRSendReceiveTabGroupLayouts(
    group: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps
): Layout[] | undefined {
    switch (group) {
        case 209:
            return [sections(singleRow(getStringRibbonId(701)))];

        default:
            return undefined;
    }
});
